import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import ReduxActions from 'reduxActions';
import TaskHelper from 'utils/taskHelper';
import addOnsSettings from 'modules/addOns/addOnsConstants';
import classNames from 'classnames';
import { isUserReadOnly } from 'utils/accessHelper';
import DeleteButton from './archive/deleteButton';
import ArchiveButton from './archive/archiveButton';

class TaskListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disableButton: { print: false, printLabel: false },
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.data !== this.props.data) {
      return true;
    }
    if (nextProps.checkedStatus !== this.props.checkedStatus) {
      return true;
    }
    if (nextState.disableButton !== this.state.disableButton) {
      return true;
    }
    return false;
  }

  _isEditable() {
    const task = this.props.data || {};
    const job = task.job || {};
    let isEditable = !isUserReadOnly();

    if (this.props.profile && this.props.profile.myjobs_setting) {
      // Check task state first
      if (['successful', 'completed'].indexOf(task.state) > -1) {
        isEditable = isEditable && this.props.profile.myjobs_setting.can_edit_after_completion;
      } else if (['submitted', 'in_progress'].indexOf(job.state) > -1) {
        isEditable = isEditable && this.props.profile.myjobs_setting.can_edit_after_submission;
      }
    }

    return isEditable;
  }

  _unarchive = () => {
    this.props.dispatch(ReduxActions.task.unarchive(this.props.data.id));
  }

  _print = () => {
    TaskHelper.print(this.props.data.id);
    this._disableButton('print');
  }

  _printLabel = () => {
    TaskHelper.printTaskLabel(this.props.data.id);
    this._disableButton('printLabel');
  }

  _updateVersaDrive = () => {
    this.props.dispatch(ReduxActions.task.submit(this.props.data.id));
  }

  _complete = () => {
    this.props.dispatch(ReduxActions.task.complete(this.props.data.id));
  }

  _cancel = () => {
    if (!Utils.Helper.isNullOrUndefined(this.props.showCancelModal)) {
      this.props.showCancelModal(this.props.data.id);
    }
  }

  _restart = () => {
    this.props.dispatch(ReduxActions.task.restart(this.props.data.id));
  }

  _viewDetail = () => {
    Utils.Router.transitionFromSubpath('tasks', this.props.data.id);
  }

  _disableButton(buttonName) {
    this.setState(prevState => ({
      disableButton: { ...prevState.disableButton, [buttonName]: true },
    }), async () => {
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.setState(prevState => ({
        disableButton: { ...prevState.disableButton, [buttonName]: false },
      }));
    });
  }

  _renderCol1() {
    const isPickup = this.props.data.job.job_type === 'pickup';

    const iconClassName = classNames({
      'versa-pickup': isPickup,
      'versa-delivery': !isPickup,
    });
    return (
      <Components.LineItem.IconBlock
        iconClassName={iconClassName}
        iconText=""
      />
    );
  }

  _renderCol2() {
    const {
      data, account, customTaskLayout, tags,
    } = this.props;
    if (Utils.Helper.isNullOrUndefined(account)) {
      return false;
    }

    const items = [];
    for (let i = 1; i < customTaskLayout.col_2.length; i += 1) {
      if (!Utils.Helper.isNullOrUndefined(customTaskLayout.col_2[i])) {
        const itemData = Utils.TaskMergeTags.translateKeyword(
          customTaskLayout.col_2[i], data, tags, null, null, account,
        );
        if (!Utils.Helper.isNullOrUndefined(itemData)) {
          items.push(
            <Components.LineItem.BlockContent key={`col-2-${i + 1}`}>
              {itemData}
            </Components.LineItem.BlockContent>,
          );
        }
      }
    }

    return (
      <Components.LineItem.Block size="MEDIUM">
        <Components.LineItem.BlockContent fontColor="BLACK" fontSize="LARGE" key="col-2-1">
          {Utils.TaskMergeTags.translateKeyword(
            customTaskLayout.col_2[0], this.props.data, tags, null, null, account,
          )}
        </Components.LineItem.BlockContent>
        {items}
      </Components.LineItem.Block>
    );
  }

  _renderCol3() {
    const {
      data, account, customTaskLayout, tags,
    } = this.props;
    if (Utils.Helper.isNullOrUndefined(account)) {
      return false;
    }

    const items = [];
    for (let i = 0; i < customTaskLayout.col_3.length; i += 1) {
      if (!Utils.Helper.isNullOrUndefined(customTaskLayout.col_3[i])) {
        const itemData = Utils.TaskMergeTags.translateKeyword(
          customTaskLayout.col_3[i], data, tags, null, null, account,
        );
        if (!Utils.Helper.isNullOrUndefined(itemData)) {
          items.push(
            <Components.LineItem.BlockContent key={`col-3-${i}`}>
              {itemData}
            </Components.LineItem.BlockContent>,
          );
        }
      }
    }
    return (
      <Components.LineItem.Block>
        {items}
      </Components.LineItem.Block>
    );
  }

  _renderCol4() {
    const {
      data, account, customTaskLayout, tags,
    } = this.props;
    if (Utils.Helper.isNullOrUndefined(account)) {
      return false;
    }

    const items = [];
    for (let i = 0; i < customTaskLayout.col_4.length; i += 1) {
      if (!Utils.Helper.isNullOrUndefined(customTaskLayout.col_4[i])) {
        const itemData = Utils.TaskMergeTags.translateKeyword(
          customTaskLayout.col_4[i], data, tags, null, null, account,
        );
        if (!Utils.Helper.isNullOrUndefined(itemData)) {
          items.push(
            <Components.LineItem.BlockContent key={`col-4-${i}`}>
              {itemData}
            </Components.LineItem.BlockContent>,
          );
        }
      }
    }

    return (
      <Components.LineItem.Block>
        {items}
      </Components.LineItem.Block>
    );
  }

  _renderCol5() {
    const {
      data, account, customTaskLayout, tags,
    } = this.props;
    if (Utils.Helper.isNullOrUndefined(account)) {
      return false;
    }

    const items = [];
    for (let i = 0; i < customTaskLayout.col_5.length; i += 1) {
      if (!Utils.Helper.isNullOrUndefined(customTaskLayout.col_5[i])) {
        const itemData = Utils.TaskMergeTags.translateKeyword(
          customTaskLayout.col_5[i], data, tags, null, null, account,
        );
        if (!Utils.Helper.isNullOrUndefined(itemData)) {
          items.push(
            <Components.LineItem.BlockContent key={`col-5-${i}`}>
              {itemData}
            </Components.LineItem.BlockContent>,
          );
        }
      }
    }

    return (
      <Components.LineItem.Block>
        {items}
      </Components.LineItem.Block>
    );
  }

  _renderCol6() {
    // Need boolean for indicating versadrive user or not
    const isVersadriver = this.props.data.state === 'waiting_for_acknowledgement'
      || this.props.data.state === 'acknowledged' || this.props.data.state === 'arrived';

    const iconClassName = classNames({
      'versa-driver': this.props.data.state === 'assigned'
        || this.props.data.state === 'started',
      'versa-vdriver': isVersadriver,
    });

    return (
      <Components.LineItem.Block>
        <Components.LineItem.BlockContent
          className={`vf-task__list-item__state--${this.props.data.state}`}
          key="col-6-1"
        >
          {this.props.strings.status[this.props.data.state]}
        </Components.LineItem.BlockContent>
        <Components.LineItem.BlockContent key="col-6-2">
          {
            Utils.Helper.isNonEmptyString(iconClassName)
              ? (
                <Components.CircleIcon
                  iconClassName={iconClassName}
                  strokeColor={isVersadriver ? Theme.Color.$gold : null}
                />
              ) : false
          }
          {((this.props.profile?.myjobs_setting?.status_visibility !== 'advanced')
            || Utils.Helper.isNullOrUndefined(this.props.data?.task_assignment?.driver))
            ? false : this.props.data.task_assignment.driver.name}
        </Components.LineItem.BlockContent>
      </Components.LineItem.Block>
    );
  }

  _renderActionButtons() {
    const task = this.props.data || {};
    const job = task.job || {};
    const printButton = (
      <Components.Button
        disabled={this.state.disableButton.print}
        hint={this.props.strings.page.buttons.print}
        iconClassName="versa-print"
        id={`${this.props.id}__print-button`}
        onClick={this._print}
      />
    );
    const printLabelButton = !Utils.Helper.isNullOrUndefined(this.props.account.addons_setting)
    && this.props.account.addons_setting.custom_task_label === addOnsSettings.subscribed
      ? (
        <Components.Button
          disabled={this.state.disableButton.printLabel}
          hint={this.props.strings.page.buttons.label}
          iconClassName="versa-label"
          id="vf-task__list-item__label__button"
          onClick={() => this._printLabel()}
        />
      ) : false;
    const unarchiveButton = this._isEditable() ? (
      <Components.Unarchive
        id={`${this.props.id}__unarchive-button`}
        modelName={this.props.strings.constants.task}
        onClick={this._unarchive}
      />
    ) : false;
    const archiveButton = this._isEditable()
      && ['submitted', 'rejected', 'draft', 'cancelled'].indexOf(job.state) > -1 ? (
        <ArchiveButton dataId={this.props.data.id} id={`${this.props.id}__archive-button`} />
      ) : false;
    const deleteButton = this._isEditable() ? (
      <DeleteButton dataId={this.props.data.id} id={`${this.props.id}__delete-button`} />
    ) : false;

    const cancelButton = this._isEditable() && !this.props.data.archived
      && ['successful', 'cancelled', 'completed'].indexOf(task.state) === -1
      && ['submitted', 'rejected', 'draft', 'cancelled'].indexOf(job.state) > -1
      ? (
        <Components.Button
          hint={this.props.strings.page.buttons.cancel}
          iconClassName="versa-danger"
          id={`${this.props.id}__cancel-button`}
          onClick={this._cancel}
        />
      ) : false;

    if (this.props.archived) {
      return (
        <Components.LineItem.ButtonGroup>
          {printButton}
          {printLabelButton}
          {unarchiveButton}
          {deleteButton}
        </Components.LineItem.ButtonGroup>
      );
    }
    const epodButton = !this.props.data.archived
      && !Utils.Helper.isNullOrUndefined(this.props.data.epod_url) ? (
        <Components.Button
          hint={this.props.strings.page.buttons.viewEPOD}
          iconClassName="versa-epod"
          id={`${this.props.id}__epod-button`}
          onClick={() => window.open(this.props.data.epod_url, '_blank')}
        />
      ) : false;

    switch (this.props.data.state) {
      case 'unassigned':
      case 'assigned':
      case 'declined':
      case 'waiting_for_acknowledgement':
      case 'acknowledged':
      case 'started':
      case 'arrived':
      case 'failed':
      case 'pending':
      case 'ongoing':
        return (
          <Components.LineItem.ButtonGroup>
            {archiveButton}
            {printButton}
            {printLabelButton}
            {cancelButton}
          </Components.LineItem.ButtonGroup>
        );
      case 'cancelled':
        return (
          <Components.LineItem.ButtonGroup>
            {archiveButton}
            {printButton}
            {printLabelButton}
          </Components.LineItem.ButtonGroup>
        );
      case 'completed':
      case 'successful':
        return (
          <Components.LineItem.ButtonGroup>
            {epodButton}
            {archiveButton}
            {printButton}
            {printLabelButton}
          </Components.LineItem.ButtonGroup>
        );
      default:
        // https://versafleet.atlassian.net/browse/VF-2413
        // Render a button group (even if empty) for the width styling
        return <Components.LineItem.ButtonGroup />;
    }
  }

  _renderStateDivider() {
    const className = classNames('vf-task__list-item__state-divider',
      `vf-task__list-item__state-divider--${this.props.data.state}`);

    return (
      <Components.LineItem.Divider className={className} />
    );
  }

  render() {
    return (
      <Components.LineItem
        checkItem={this.props.checkItem}
        checkedStatus={this.props.checkedStatus}
        id={this.props.id}
        itemID={this.props.data.id}
        onClick={this._viewDetail}
        showCheckBox
      >
        {this._renderCol1()}
        {this._renderCol2()}
        <Components.LineItem.Divider />
        {this._renderCol3()}
        <Components.LineItem.Divider />
        {this._renderCol4()}
        <Components.LineItem.Divider />
        {this._renderCol5()}
        {!this.props.archived ? this._renderStateDivider() : false}
        {!this.props.archived ? this._renderCol6() : false}
        {(!Utils.Helper.isNullOrUndefined(this.props.renderActionButtons))
          ? this.props.renderActionButtons(this.props.data)
          : this._renderActionButtons()}

      </Components.LineItem>
    );
  }
}

TaskListItem.propTypes = {
  account: PropTypes.shape().isRequired,
  archived: PropTypes.bool,
  checkItem: PropTypes.func,
  checkedStatus: PropTypes.bool,
  customTaskLayout: PropTypes.shape(),
  data: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string,
  profile: PropTypes.shape({
    myjobs_setting: PropTypes.shape({
      can_edit_after_completion: PropTypes.bool,
      can_edit_after_submission: PropTypes.bool,
      status_visibility: PropTypes.string,
    }),
  }),
  renderActionButtons: PropTypes.func,
  showCancelModal: PropTypes.func,
  strings: PropTypes.shape({
    constants: PropTypes.shape({
      task: PropTypes.string,
    }),
    status: PropTypes.shape(),
    page: PropTypes.shape({
      buttons: PropTypes.shape({
        print: PropTypes.string,
        unarchive: PropTypes.string,
        cancel: PropTypes.string,
        viewEPOD: PropTypes.string,
        label: PropTypes.string,
      }),
    }),
  }).isRequired,
  tags: PropTypes.shape({}),
};

TaskListItem.defaultProps = {
  archived: false,
  checkedStatus: false,
  checkItem: null,
  customTaskLayout: {
    col_2: ['account_name', 'task_contact_person', 'task_id', 'tracking_id'],
    col_3: ['task_address', 'task_time_range'],
    col_4: ['task_scheduled_time'],
    col_5: ['task_tags', 'item_summary'],
  },
  id: 'vf-task__list-item',
  profile: {},
  renderActionButtons: null,
  showCancelModal: null,
  tags: {},
};

const mapStateToProps = (state) => {
  const { profile } = state;
  return {
    profile: profile.profile,
  };
};

export default connect(mapStateToProps)(translate('Task')(TaskListItem));
